// src/hooks/useUnseenFeedbackCount.js
// Cuenta cuántas respuestas de estudio y notas personales tienen feedback de mentor
// que el estudiante todavía no ha visto (mentorFeedback.text presente y
// mentorFeedback.seenByStudent no marcado). Usado para el badge de "Mi Cuenta" y
// el punto rojo sobre el ícono de perfil en Layout.js.

import { useState, useEffect, useCallback } from "react";
import { getAllUserResponses } from "../services/study-service";
import { getMyPersonalNotes } from "../services/reflection-service";

function isUnseenFeedback(item) {
  return !!item.mentorFeedback?.text && !item.mentorFeedback?.seenByStudent;
}

export function useUnseenFeedbackCount(userId) {
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    if (!userId) {
      setCount(0);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const [responses, notes] = await Promise.all([
        getAllUserResponses(userId),
        getMyPersonalNotes(userId),
      ]);
      const unseen =
        responses.filter(isUnseenFeedback).length +
        notes.filter(isUnseenFeedback).length;
      setCount(unseen);
    } finally {
      setLoading(false);
    }
  }, [userId]);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { count, loading, refresh };
}
